import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { fetchUser } from '@/api';
import camelcaseKeys from 'camelcase-keys';
import userKeys from '@/queries/user/userKeys';
import { queryClient } from '@/components/App';

export interface User {
    id: number;
    email: string;
    firstname: string;
    lastname: string;
    language: string;
    avatar: string;
    timezone: string;
    country: string;
    currency: string;
    pricing: string;
    showsMax: number;
    numberInvitations: number;
    archivedShowsMax: number;
    activated: boolean;
    maximumTrialEpisodes: number;
    emailVerifiedAt: Date;
    trialEndsAt: Date;
    createdAt: Date;
    updatedAt: Date;
    deletedAtNotNull: Date;
    pmType: string;
    pmLastFour: string;
    external: boolean;
    links: {
        self: string;
        userUpdate: string;
        passwordUpdate: string;
        emailUpdate: string;
        avatarUpdate: string;
    };
    canArchiveShows: boolean;
    canHostOnAusha: boolean;
    guest: boolean;
    intercomToken: string;
    options: string[];
    showsCount: number;
    surveys: string[];
    trialEpisodes: number;
}

const transform = (data: unknown) => {
    return camelcaseKeys(data as any, { deep: true });
};

const queryFn = async () => {
    const { data } = await fetchUser();

    // TODO: Do camelcase transformation in Axios interceptor
    return transform(data);
};

const useUserQuery = (): UseQueryResult<User> => {
    return useQuery({
        queryKey: userKeys.detail(),
        queryFn,
    });
};

export const prefetchUserQuery = async () => {
    await queryClient.prefetchQuery({
        queryKey: userKeys.detail(),
        queryFn,
    });
};

export default useUserQuery;
